module.exports = __webpack_public_path__ + "static/media/480.2f97e10b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-ant/light/480.png
// module id = 1868
// module chunks = 2